import { NAMESPACE } from '../../constants';

export const FETCH_RECURLY_SUBSCRIPTIONS = `${NAMESPACE}/FETCH_RECURLY_SUBSCRIPTIONS` as const;
export const CANCEL_RECURLY_SUBSCRIPTION = `${NAMESPACE}/CANCEL_RECURLY_SUBSCRIPTION` as const;
export const RESET_SUBSCRIPTIONS_REDUCER = `${NAMESPACE}/RESET_SUBSCRIPTION_REDUCER` as const;
export const FETCH_AUTOREFILL_STATUS = `${NAMESPACE}/FETCH_AUTOREFILL_STATUS` as const;
export const UPDATE_AUTOREFILL_STATUS = `${NAMESPACE}/UPDATE_AUTOREFILL_STATUS` as const;
